/* eslint-disable function-paren-newline */
import { useCallback, useRef } from 'react';

export default function useDoOnce<T extends (...args: any[]) => any>(
  callback: T,
): (...args: Parameters<T>) => ReturnType<T> | undefined {
  const hasExecuted = useRef(false);
  const callbackRef = useRef(callback);

  // Keep the callback ref up to date
  callbackRef.current = callback;

  return useCallback((...args: Parameters<T>) => {
    if (hasExecuted.current) return undefined;
    hasExecuted.current = true;
    return callbackRef.current(...args);
  }, []);
}
